<template>
  <!-- Contatti utili (pattern .settings-card): testa con "Nuovo contatto",
       i contatti affiancati in .settings-pair, ciascuno in un riquadro tenue
       (.tint-box) con il proprio modulo; stato vuoto se non ce ne sono -->
  <section class="shadowedCard p-4 settings-card mb-4">
    <div class="section-head section-head--stack mb-3">
      <b-icon icon="people" class="section-head__icon" aria-hidden="true"></b-icon>
      <h2 class="section-title mb-0 mr-auto">{{ $t('ContattiEmergenza.title') }}</h2>
      <b-button
        variant="primary"
        class="section-head__action"
        @click="$bvModal.show('add-contact')"
      >
        <b-icon icon="plus" aria-hidden="true"></b-icon>
        {{ $t('ContattiEmergenza.newContact') }}
      </b-button>
    </div>
    <div v-if="contacts && contacts.length" class="settings-pair">
      <div
        v-for="(contact, indx) in contacts"
        :key="contact.hashid"
        class="tint-box"
      >
        <EditEmergencyContact
          :contact="contact"
          @saved-contact="handleSavedContact"
        >
        </EditEmergencyContact>
      </div>
    </div>
    <div v-else-if="contacts && contacts.length == 0" class="empty-state">
      <b-icon icon="people" class="empty-state__icon" aria-hidden="true"></b-icon>
      <p>{{ $t('ContattiEmergenza.none') }}</p>
    </div>
    <b-modal
      id="add-contact"
      size="lg"
      centered
      :title="$t('ContattiEmergenza.modalTitle')"
      button-size="sm"
      hide-footer
      :cancel-title="$t('ContattiEmergenza.cancel')"
      cancel-variant="popup-button mr-2"
      :ok-title="$t('ContattiEmergenza.save')"
      ok-variant="popup-button"
      footer-class="border-0"
    >
      <NewEmergencyContact
        :hashid="user.hashid"
        @saved-contact="handleSavedContact"
      ></NewEmergencyContact>
    </b-modal>
  </section>
</template>

<script>
import Vue from "vue";
import { cittadinoService } from "@/_services";
import NewEmergencyContact from "@/app/modules/impostazioni/components/utente/NewEmergencyContact.vue";
import EditEmergencyContact from "@/app/modules/impostazioni/components/utente/EditEmergencyContact.vue";
import { mapState, mapActions } from "vuex";
export default {
  name: "ContattiEmergenza",
  props: ["user"],
  // computed: {
  //   ...mapState("utility", ["searching", "comuni", "province", "regioni"]),
  // },
  components: {
    NewEmergencyContact,
    EditEmergencyContact,
  },
  data() {
    return {
      editIndexes: [false, false, false],
      avatarPath: null,
      selected: {
        regione: null,
        provincia: null,
        comune: null,
      },
      anagrafica: {
        regione: null,
        provincia: null,
        comune: null,
        cap: null,
        address: null,
        name: null,
        surname: null,
        cf: null,
        gender: null,
        birthday: null,
        ts_number: null,
        tel_number: null,
      },
      enableBtn: false,
      isPost: true,
      selectingImage: false,
      contacts: null,
    };
  },
  methods: {
    // ...mapActions("utility", ["getComuni", "getProvince", "getRegioni"]),
    ...mapActions("utente", ["setAnagrafica", "me"]),
    ...mapActions({
      clearAlert: "alert/clear",
      errorAlert: "alert/error",
      successAlert: "alert/success",
      infoAlert: "alert/info",
    }),
    fetchUserContacts() {
      var self = this;
      cittadinoService
        .getUserEmergencyContacts(this.user.hashid)
        .then(function (res) {
          self.contacts = res.data.data;
          // self.memberList = res.data.data;
        })
        .catch(function (err) {
          console.log(err);
          self.notFound = true;
          window.scrollTo(0, 0);
          self.errorAlert(self.$t('ContattiEmergenza.loadError'))
        });
    },
    handleSavedContact() {
      this.fetchUserContacts();
      this.$bvModal.hide("add-contact");
    },
  },
  created() {
    this.fetchUserContacts();
  },
  mounted() {},
};
</script>
